import type { CategoryInterface, NomenclatureGroupInterface } from '@/types'

import cn from './BreadcrumbItem.module.scss'

type BreadcrumbItemProps = {
  item?: CategoryInterface | NomenclatureGroupInterface
  isFirst?: boolean
  onClick: () => void
  showAllLabel: boolean
}

function BreadcrumbItem({
  item,
  isFirst,
  onClick,
  showAllLabel,
}: BreadcrumbItemProps) {
  const getLabel = () => {
    if (isFirst) return showAllLabel ? 'Все' : ''
    if (!item) return ''

    if ('category' in item) return item.category.description
    if ('nomenclatureGroup' in item) return item.nomenclatureGroup.description
    return ''
  }

  const label = getLabel()
  if (!label) return null

  return (
    <span onClick={onClick} className={cn.item}>
      {label}
    </span>
  )
}

export default BreadcrumbItem
